import React, { useState, useCallback } from 'react';
import { Button } from 'antd';

export default function FormSubmitButton({ onClick, useSmartLoading, ...props }) {
  const [loading, setLoading] = useState(false);
  const onSmartClick = useSmartLoading
    ? async (e) => {
      const res = onClick(e);

      if (res instanceof Promise) {
        setLoading(true);
        try {
          await res;
        } catch (e) {

        }
        setLoading(false);
      }
    }
    : onClick;

  return (
    <Button
      loading={loading}
      onClick={onSmartClick}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/SubmitButton.js